import React from "react";
import { IPermitApplicationContext } from "./types";
import { INITIAL_STATE } from "./reducer";

/**
 * Default context value used to detect if hook is used outside provider
 */
export const DEFAULT_PERMIT_APPLICATION_CONTEXT: IPermitApplicationContext = {
  state: INITIAL_STATE,
  setAuthority: () => undefined,
  setPermitType: () => undefined,
  setSelectedVehicles: () => undefined,
  updateDocument: () => undefined,
  clearDocument: () => undefined,
  acceptTerms: () => undefined,
  clearTerms: () => undefined,
  resetApplication: () => undefined,
  isStepComplete: () => false,
  canProceedToStep: () => false,
};

/**
 * Context for managing permit application form state across multiple routes
 */
export const PermitApplicationContext = React.createContext<IPermitApplicationContext>(
  DEFAULT_PERMIT_APPLICATION_CONTEXT,
);

export default PermitApplicationContext;
